import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect } from 'react';

type Props = {
  displayTime?: boolean;
  message: string;
  close: any;
  handleSaveBtn?: any;
  button?: {
    saveLabel: string;
    closeLabel: string;
  };
  title?: string;
  gotIt?: boolean;
};

function InfoModal({
  displayTime = true,
  handleSaveBtn,
  message,
  close,
  button = {
    saveLabel: 'Save',
    closeLabel: 'Cancel',
  },
  title,
  gotIt,
}: Props) {
  useEffect(() => {
    if (displayTime) {
      setTimeout(() => {
        close();
      }, 2000);
    }
  }, []);

  return (
    <Box width={600}>
      <DialogTitle
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: 0.0075,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      {gotIt ? (
        <DialogActions>
          <Button
            autoFocus
            onClick={close}
          >
            {'Got it'}
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button
            autoFocus
            onClick={close}
          >
            {button.closeLabel}
          </Button>
          <Button
            autoFocus
            variant="contained"
            onClick={handleSaveBtn}
          >
            {button.saveLabel}
          </Button>
        </DialogActions>
      )}
    </Box>
  );
}

export default InfoModal;
